import { Component, OnInit } from "@angular/core";
import {AuthService} from "src/services/auth.service";
import {User} from "src/models/user.model";
import {Account} from "src/models/account.model";
import {Router} from "@angular/router";
import {RefresherService} from "src/services/refresher.service";
import {AuditService} from "src/services/audit.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {

  collapseShow = "hidden";
  isMenuOpen = false;
  userAuth: User;
  isReportsMenuOpen = false;

  public account: Account;

  constructor(
    public auth: AuthService,
    public router: Router,
    private refresher: RefresherService,
    private auditService: AuditService
    ) {

    this.auth.user$.subscribe(user => this.userAuth = user);

  }

  ngOnInit() {
    this.account = JSON.parse(localStorage.getItem('account'));
  }

  toggleCollapseShow(classes) {
    this.collapseShow = classes;
  }

  async routerLinks(router: any){
    // Log navigation action before routing
    const pageName = this.getPageNameFromRoute(router);
    await this.auditService.logNavigation(router, pageName);

    this.router.navigateByUrl(router, {replaceUrl: true});
    this.refresher.notifyOther({loadDashboard: true});
  }

  // Add navigation logging for standard router links
  async logNavigation(route: string, pageName: string) {
    await this.auditService.logNavigation(route, pageName);
  }

  private getPageNameFromRoute(route: string): string {
    // Extract meaningful page name from route
    if (route.includes('/dashboard')) return 'Dashboard';
    if (route.includes('/employees')) return 'Employee Management';
    if (route.includes('/reports')) return 'Reports';
    if (route.includes('/zones')) return 'Zone Management';
    if (route.includes('/settings')) return 'Settings';

    // Fallback: extract last segment and format
    const segments = route.split('/').filter(s => s);
    const lastSegment = segments[segments.length - 1];
    return lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1);
  }

  toggleMobileMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    this.collapseShow = this.isMenuOpen ? 'mobile-menu-open' : 'hidden';
  }

  closeMobileMenu() {
    this.isMenuOpen = false;
    this.collapseShow = 'hidden';
  }

  toggleReportsMenu() {
    this.isReportsMenuOpen = !this.isReportsMenuOpen;
  }

}
